import React from 'react';
import { Youtube, FileText, Mic, PenTool, LayoutTemplate, Database } from 'lucide-react';
import { SlideLayout } from '../SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ProspectFeaturesSlide(props: SlideProps) {
  const features = [{
    icon: <Youtube className="w-6 h-6" data-id="element-197" />,
    title: 'Multi-Format Input',
    desc: 'Works with YouTube videos, PDFs, PPTs, Docs, and Audio files.',
    color: 'text-red-500 bg-red-50'
  }, {
    icon: <FileText className="w-6 h-6" data-id="element-198" />,
    title: 'AI Question Gen',
    desc: 'Automatically creates MCQs, Short Answer, and True/False questions.',
    color: 'text-blue-500 bg-blue-50'
  }, {
    icon: <PenTool className="w-6 h-6" data-id="element-199" />,
    title: 'Manual Editing',
    desc: 'Full control to tweak wording, add options, or replace questions.',
    color: 'text-purple-500 bg-purple-50'
  }, {
    icon: <LayoutTemplate className="w-6 h-6" data-id="element-200" />,
    title: 'Branded Exports',
    desc: 'PDFs automatically include your school logo, header, and instructions.',
    color: 'text-emerald-500 bg-emerald-50'
  }, {
    icon: <Database className="w-6 h-6" data-id="element-201" />,
    title: 'Metadata & Keys',
    desc: 'Generates answer keys, difficulty levels, and topic tags automatically.',
    color: 'text-amber-500 bg-amber-50'
  }, {
    icon: <Mic className="w-6 h-6" data-id="element-202" />,
    title: 'Lecture to Quiz',
    desc: 'Record a live lecture and turn it into a quiz instantly.',
    color: 'text-indigo-500 bg-indigo-50'
  }];
  return <SlideLayout {...props} title="Everything You Need" subtitle="A complete toolkit designed for modern educators." data-id="element-203">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8" data-id="element-204">
        {features.map((feature, idx) => <div key={idx} className="p-6 rounded-2xl border border-slate-100 hover:shadow-lg hover:border-indigo-100 transition-all bg-white group" data-id="element-205">
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${feature.color} group-hover:scale-110 transition-transform`} data-id="element-206">
              {feature.icon}
            </div>
            <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-207">
              {feature.title}
            </h3>
            <p className="text-slate-500 text-sm leading-relaxed" data-id="element-208">
              {feature.desc}
            </p>
          </div>)}
      </div>
    </SlideLayout>;
}